<template>
    <div class="finishDownArrow">
        <div v-bind:class="dropdownAccount">
            <multiselect v-model="displayValue" :options="options" :multiple="false" group-values="libs" group-label="AccountType" :show-labels="false" :group-select="false" placeholder="Type to search" track-by="name" label="name">
                <p slot="noResult" class="text-danger"> Oops! No Account found.</p>
                <span slot="noResult" class="btn btn-primary btn-round" v-on:click="addModal('Add')">Create new Account</span><br />
            </multiselect>
        </div>
        <modal :show="showModal" v-if="showModal">

            <div class="modal-header">
                <h5 class="modal-title" id="myModalLabel">Add Account</h5>
            </div>
            <div class="modal-body">
                <form>

                    <div class="form-row">
                        <div class="form-group col-md-6" v-if="type=='Add'">
                            <label>Account Type</label>
                            <select v-model="accountTypeId" class="form-control" v-if="showModal">
                                <option value="">Select account Type</option>
                                <option v-for="accountType in Accounts.accountTypes" v-bind:key="accountType.id" :value="accountType.id">{{ accountType.name }}</option>
                            </select>
                        </div>
                        <div class="form-group col-md-6" v-if="type=='Add'">
                            <label>Cost Center</label>
                            <span v-if="accountTypeId!== undefined">
                                <select v-model="newAccount.costCenterId" class="form-control" v-if="showModal">
                                    <option value="-1">Select cost Center</option>
                                    <option v-for="costCenter in costCenters" v-bind:key="costCenter.id" :value="costCenter.id">{{ costCenter.name }}</option>
                                </select>
                            </span>
                        </div>
                        <div class="form-group" v-bind:class="{'has-danger': $v.newAccount.code.$error, 'col-md-4' :type== 'Add' , 'col-md-12':type=='Edit' }">
                            <label>Code</label>
                            <input v-model.trim="$v.newAccount.code.$model" class="form-control" />
                            <span v-if="!$v.newAccount.code.required && $v.newAccount.code.$error" class="error validation-error field-validation-valid">Code is required.</span>
                            <span v-if="!$v.newAccount.code.isExist && $v.newAccount.code.$error" class="error validation-error field-validation-valid">Code is already exist</span>

                        </div>

                        <div class="form-group" v-bind:class="{'has-danger': $v.newAccount.name.$error, 'col-md-8' :type== 'Add' , 'col-md-12':type=='Edit' }">
                            <label>Name</label>
                            <input v-model.trim="$v.newAccount.name.$model" class="form-control" />
                            <span v-if="!$v.newAccount.name.required && $v.newAccount.name.$error" class="error validation-error field-validation-valid">Name is required.</span>

                        </div>

                        <div class="form-group col-md-12">
                            <label>Description</label>
                            <textarea v-model="newAccount.description" class="form-control" />
                        </div>

                        <div class="form-group col-md-12">

                            <label style="margin: 7px;">Active</label> <br />
                            <div class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" v-bind:class="{'bootstrap-switch-on': newAccount.isActive, 'bootstrap-switch-off': !newAccount.isActive}" v-on:click="newAccount.isActive = !newAccount.isActive" style="width: 72px;">

                                <div class="bootstrap-switch-container" style="width: 122px; margin-left: 0px;">
                                    <span class="bootstrap-switch-handle-on bootstrap-switch-success" style="width: 50px;">
                                        <i class="nc-icon nc-check-2"></i>

                                    </span>
                                    <span class="bootstrap-switch-label" style="width: 30px;">&nbsp;</span>
                                    <span class="bootstrap-switch-handle-off bootstrap-switch-success" style="width: 50px;">

                                        <i class="nc-icon nc-simple-remove"></i>

                                    </span>
                                    <input class="bootstrap-switch" type="checkbox" data-toggle="switch" checked="" data-on-label="<i class='nc-icon nc-check-2'></i>" data-off-label="<i class='nc-icon nc-simple-remove'></i>" data-on-color="success" data-off-color="success">

                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer justify-content-center">
                <button type="button" class="btn btn-secondary btn-round" v-on:click="close()">Cancel</button>
                <button type="button" class="btn btn-primary btn-round" v-on:click="addAccount(newAccount)" :disabled="$v.newAccount.$invalid">Save</button>
            </div>
        </modal>
    </div>

</template>
<script>
    import { required } from "vuelidate/lib/validators";
    import Multiselect from 'vue-multiselect'
    export default {
        components: {
            'multiselect': Multiselect
        },

        props: ['value', 'accounts', 'accountsvalue', 'dropdownaccount','prop'],
        data: function () {
            return {
                dropdownAccount: "",
                showModal: false,
                Accounts: [],
                selectValue: [],
                options: [],
                type: '',
                accountTypeId: '00000000-0000-0000-0000-000000000000',
                costCenters: [],
                newAccount: {
                    id: '',
                    code: '',
                    costCenterId: '',
                    name: '',
                    isActive: true,
                    description: ''
                }
            }
        },
        computed: {
            displayValue: {
                get: function () {

                    return this.selectValue;
                },
                set: function (modifiedValue) {

                    if (modifiedValue != null) {
                        this.selectValue = modifiedValue;
                        this.$emit('input', modifiedValue.id);
                    }
                }
            }

        },
        mounted: function () {
            
            this.dropdownAccount = this.dropdownaccount;
            this.isopen = true;
            this.selectValue = this.value;
            var root = this;
            var token = '';
            if (this.$session.exists()) {
                token = localStorage.getItem('token');
            }
             
            root.$https.get('/Accounting/GetCOA', { headers: { "Authorization": `Bearer ${token}` } })
                .then(function (response) {
                
                    root.Accounts = response.data;

                    root.$store.dispatch('GetAccountList', root.Accounts);
                    root.Accounts = root.$store.state.accounts
                    root.Accounts.accountTypes.forEach(function (accountType) {
                        var arr = [];
                        accountType.costCenters.forEach(function (costCenter) {

                            if (costCenter.code =='105000' && root.prop=='Bank') {
                                costCenter.accounts.forEach(function (account) {
                                    arr.push({ name: account.code + ": " + account.name, id: account.id });
                                });
                            }

                            if ((costCenter.code == '101000' || costCenter.code == '105000') && root.prop =='CashBank') {
                                costCenter.accounts.forEach(function (account) {
                                    arr.push({ name: account.code + ": " + account.name, id: account.id });
                                });
                            }

                            if ((costCenter.code == '605050' || costCenter.code == '605001') && root.prop == 'Expense') {
                                costCenter.accounts.forEach(function (account) {
                                    arr.push({ name: account.code + ": " + account.name, id: account.id });
                                });
                            }
                        });
                        
                        root.options.push({
                            AccountType: accountType.name,
                            libs: arr
                        });
                    });
                });
            
            this.GetAccount();
            if (this.accounts != undefined) {
                this.options = this.accounts;
            }

            this.selectValue = this.accountsvalue;


        },

        validations: {
            newAccount: {
                code: {
                    required: required,                
                },
                name: {
                    required: required
                }
            }
        },

        methods: {
            GetAccount: function () {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                if (this.selectValue != null && this.selectValue != '' && this.selectValue != undefined) {
                    root.$https.get('/Accounting/GetAccount?id=' + this.selectValue, { headers: { "Authorization": `Bearer ${token}` } })
                        .then(function (response) {
                            if (response.data.value) {
                                root.selectValue = { name: response.data.account.name, id: root.selectValue };
                            }
                        });
                }
                
            },
            addModal: function (type) {
                this.$v.$reset();
                this.showModal = !this.showModal;
                this.type = type;

                this.newAccount = {
                    id: '',
                    code: '',
                    costCenterId: "00000000-0000-0000-0000-000000000000",
                    name: '',
                    isActive: true,
                    description: ''
                };

            },

            addAccount: function (account) {
                account.id = "00000000-0000-0000-0000-000000000000";
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.post('/Accounting/AddAccount', account, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data.value === true) {


                            root.Accounts.accountTypes.find(function (x) {
                                return x.id === root.accountTypeId;
                            }).costCenters.find(function (y) {
                                return y.id === root.newAccount.costCenterId;
                            }).accounts.push({
                                costCenterId: root.newAccount.costCenterId,
                                code: root.newAccount.code,
                                description: root.newAccount.description,
                                id: response.data.id,
                                isActive: root.newAccount.isActive,
                                name: root.newAccount.name
                            });


                            root.options.filter(function (e) { return e.AccountType === 'Assets'; })[0]
                                .libs
                                .push({ name: root.newAccount.code + ": " + root.newAccount.name, id: response.data.id });

                            root.showModal = !root.showModal;


                        } else {

                            root.$swal({
                                title: 'Error!',
                                text: 'Account does not add.',
                                type: 'error',
                                confirmButtonClass: "btn btn-info",
                                buttonsStyling: false
                            });

                        }
                    },
                        function (error) {
                            root.$swal({
                                title: 'Error!',
                                text: error,
                                type: 'error',
                                confirmButtonClass: "btn btn-info",
                                buttonsStyling: false
                            });
                        });
            },
            close: function () {
                this.showModal = !this.showModal;
            }
        },
        watch:
        {
            account: function (a) {
                //compatibilty with chrome
                this.oldCode = a.code;
            },
            accountTypeId: function (newTypeId) {
                this.costCenters = this.Accounts.accountTypes.find(function (x) { return x.id == newTypeId; }).costCenters;
            }
        }

    }

</script>

